import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
// Need to parse the string using parseISO() then format the date using format()
// https://date-fns.org/v2.13.0/docs/parseISO
// https://date-fns.org/v2.13.0/docs/format

class DisplayFormatterService {
  constructor () {
    this.currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    this.numberFormatter = new Intl.NumberFormat('en-US');
  }

  formatDayMonthDate (dateToFormat) {
    if ((dateToFormat || null) === null) return '';

    try {
      var date = new Date(parseISO(dateToFormat));
      return format(date, 'MMM d');
    } catch (ex) {
      return '';
    }
  }

  formatDate (dateToFormat) {
    if ((dateToFormat || null) === null) return '';

    try {
      var date = new Date(parseISO(dateToFormat));
      return format(date, 'MMM d, yyyy');
    } catch (ex) {
      return '';
    }
  }

  formatCurrency (numberToFormat) {
    if ((numberToFormat || null) === null) {
      return this.currencyFormatter.format(0);
    }

    var asNumber = parseFloat(numberToFormat);
    if (isNaN(asNumber)) {
      return numberToFormat;
    } else {
      return this.currencyFormatter.format(asNumber);
    }
  }

  formatNumber (num) {
    if ((num || null) === null) {
      return this.numberFormatter.format(0);
    }

    var asNumber = parseInt(num);
    if (isNaN(asNumber)) {
      return num;
    } else {
      return this.numberFormatter.format(asNumber);
    }
  }

  formatBool (bool) {
    return bool ? 'Yes' : 'No';
  }
}

var x = new DisplayFormatterService();
export default x;
